import { Link, useParams } from "react-router-dom";
import data from "../../data/projects_db.json";
import images from "../../utils/imageLoader";
import Seo from "../../components/Seo";
import ProjectGallery from "../../components/projects/ProjectGallery";
import "../../style/style-pages/projectpage.css";

const ProjectDetails = () => {
    const { id } = useParams();
    const projectIndex = Number(id) - 1;
    const project = data.projects[projectIndex];
    const isValid = Number.isInteger(projectIndex) && projectIndex >= 0 && projectIndex < data.projects.length;

    if (!isValid) {
        return <main className="project-page"><Seo canonicalPath={`/projects/${id}`} description="This WiseCursor project page is not available." noIndex title="Project not found" /><div className="project-page__shell project-page__empty"><p className="project-page__eyebrow">PROJECTS</p><h1>Project not found</h1><p>That project link is not available.</p><Link className="project-page__back" to="/projectpage">Back to projects</Link></div></main>;
    }

    return (
        <main className="project-page">
            <Seo canonicalPath={`/projects/${project.id}`} description={project.desc} title={project.name} />
            <div className="project-page__shell">
                <Link className="project-page__back" to="/projectpage">← Back to projects</Link>
                <header className="project-page__header">
                    <p className="project-page__eyebrow">{project.category || "Case study"}</p>
                    <h1>{project.name}</h1>
                    <p className="project-page__intro">{project.desc}</p>
                    <span className="project-page__status">{project.status}</span>
                </header>

                <figure className="project-page__hero-media">
                    <img src={images[project.image]} alt={`${project.name} preview`} />
                </figure>

                <ProjectGallery project={project} />

                <div className="project-page__content">
                    <aside className="project-page__readiness">
                        <p className="project-page__eyebrow">READINESS</p>
                        <h2>{project.readiness}</h2>
                        <p>This page distinguishes verified work from concepts and outcomes that still need validation.</p>
                        <div className="project-page__readiness-item"><strong>Status</strong><span>{project.status}</span></div>
                        <div className="project-page__readiness-item"><strong>Evidence</strong><span>{project.evidence}</span></div>
                        {project.liveUrl ? (
                            <a className="project-page__evidence-link" href={project.liveUrl} target="_blank" rel="noreferrer">
                                View public project ↗
                            </a>
                        ) : (
                            <p className="project-page__evidence-note">Evidence available on request.</p>
                        )}
                    </aside>

                    <div className="project-page__sections">
                        {[
                            ["Challenge", project.challenge],
                            ["Role & contribution", project.role],
                            ["Process", project.process],
                            ["Outcome & current value", project.outcome]
                        ].map(([title, body]) => (
                            <section className="project-page__section" key={title}>
                                <div><p className="project-page__eyebrow">PROJECT SNAPSHOT</p><h2>{title}</h2></div>
                                <p>{body}</p>
                            </section>
                        ))}
                    </div>
                </div>
            </div>
        </main>
    );
};

export default ProjectDetails;
